import { app } from '../../../../app';
import { Controller } from './company-verification.controller';

app.component('companyVerification', {
    controller: Controller,
    templateUrl: require('./company-verification.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/company/company-verification.component.js